module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"file-uploader\">\n	<input class=\"file-input\" type=\"file\" style=\"display: none;\" ")
    ;  if (accept) { 
    ; __append("accept=\"")
    ; __append(escapeFn( accept ))
    ; __append("\"")
    ;  } 
    ; __append(">\n	<div class=\"file-progresses\"></div>\n	<div class=\"file-errors\"></div>\n	<button class=\"btn upload-file\">Загрузить</button>\n</div>\n")
  }
  return __output.join("");

}